import { AMPLITUDE_SESSION_TIMEOUT, AMPLITUDE_START_SESSION_EVENT_TYPE } from './amplitudeSessionConstants';

let backgroundedAt: number | null = null;
let unsubscribeLifecycleTracking: (() => void) | undefined;

/**
 * Starts a new Amplitude session when Electron returns after the configured inactivity period.
 */
export const initialiseElectronAmplitudeLifecycleTracking = (): (() => void) | undefined => {
    if (unsubscribeLifecycleTracking) return unsubscribeLifecycleTracking;

    const unsubscribe = window.desktopIntegration?.onLifecycleStateChange?.(({ state, occurredAt }) => {
        if (state === 'background') {
            backgroundedAt = occurredAt;
            return;
        }

        if (!backgroundedAt || occurredAt - backgroundedAt < AMPLITUDE_SESSION_TIMEOUT) {
            backgroundedAt = null;
            return;
        }

        backgroundedAt = null;

        const amplitudeInstance = window.amplitude.getInstance();
        amplitudeInstance.resetSessionId();
        amplitudeInstance.logEvent(AMPLITUDE_START_SESSION_EVENT_TYPE);
    });

    if (!unsubscribe) return unsubscribe;

    const unsubscribeLifecycleTrackingCallback = () => {
        try {
            unsubscribe();
        } finally {
            if (unsubscribeLifecycleTracking === unsubscribeLifecycleTrackingCallback) {
                backgroundedAt = null;
                unsubscribeLifecycleTracking = undefined;
            }
        }
    };

    unsubscribeLifecycleTracking = unsubscribeLifecycleTrackingCallback;

    return unsubscribeLifecycleTracking;
};
